import React from "react";

export default function PeriodToggle({ value, onChange }) {
    return (
        <div className="flex shrink-0 rounded-md border border-gray-200 p-0.5 text-[11px] font-medium">
            {['month', 'year'].map((opt) => (
                <button
                    key={opt}
                    type="button"
                    onClick={() => onChange(opt)}
                    className={`rounded px-2.5 py-1 capitalize transition ${
                        value === opt
                            ? 'bg-gray-900 text-white'
                            : 'text-gray-500 hover:text-gray-800'
                    }`}
                >
                    {opt === 'month' ? 'Monthly' : 'Yearly'}
                </button>
            ))}
        </div>
    );
}